import styled from 'styled-components';

import { spaceMixin, token } from '@zillow/constellation';

export const StyledContainer = styled.div`
  display: flex;
  border-radius: 4px;
  background-color: ${token('colors.blue200')};
  padding: ${spaceMixin('md')};
`;
